module.exports = __webpack_public_path__ + "media/images/web/dummy-94445a7b8d709639e7de1261819ca2b3.png";